import { MissionAssessmentFieldName } from '@@types/api.types';
import type { PromptGuidelines } from '@components/shared/prompt-popover.component';
import maDefinitions from '@data/ma-definitions.json';

export const TRL_ANALYSIS_PROMPT_GUIDELINES: PromptGuidelines = {
  title: 'TRL Analysis',
};

export const TRL_PROJECTION_ANALYSIS_PROMPT_GUIDELINES: PromptGuidelines = {
  title: 'TRL Projection Analysis',
};

export const SIMILAR_TECHNOLOGIES_PROMPT_GUIDELINES: PromptGuidelines = {
  title: 'Similar Technologies',
};

export const MISSION_ASSESSMENT_PROMPT_GUIDELINES: Record<MissionAssessmentFieldName, PromptGuidelines> = {
  [MissionAssessmentFieldName.GENERAL_NOTES]: {
    title: 'Capability Assessment',
    subtitle: 'Assessment General Notes',
  },

  [MissionAssessmentFieldName.THREATS]: {
    title: 'Capability Assessment',
    subtitle: 'Threats and Responses',
  },

  [MissionAssessmentFieldName.STRATEGIC]: {
    title: 'Capability Assessment',
    subtitle: 'Strategic and Operational Alignment',
  },

  [MissionAssessmentFieldName.RISKS]: {
    title: 'Capability Assessment',
    subtitle: 'Risks and Issues',
  },

  [MissionAssessmentFieldName.SUSTAINMENT]: {
    title: 'Capability Assessment',
    subtitle: 'Sustainment Considerations',
  },

  [MissionAssessmentFieldName.NEXT_TRL]: {
    title: 'Hurdles to Next TRL',
    subtitle: 'Notes',
  },

  [MissionAssessmentFieldName.NEXT_MRL]: {
    title: 'Hurdles to Next MRL',
    subtitle: 'Notes',
  },

  [MissionAssessmentFieldName.SUPPLY_CHAIN]: {
    title: 'Hurdles',
    subtitle: 'Hurdles to Supply Chain',
  },

  [MissionAssessmentFieldName.INTEROPERABLE_NAME]: {
    title: 'Interoperable Technology',
    subtitle: 'Name',
    definition: maDefinitions.interoperable,
  },

  [MissionAssessmentFieldName.INTEROPERABLE_DESCRIPTION]: {
    title: 'Interoperable Technology',
    subtitle: 'Description',
    definition: maDefinitions.interoperable,
  },

  [MissionAssessmentFieldName.INTEROPERABLE_NOTES]: {
    title: 'Interoperable Technology',
    subtitle: 'Notes',
    definition: maDefinitions.interoperable,
  },

  [MissionAssessmentFieldName.INTERCHANGEABLE_NAME]: {
    title: 'Interchangeable Technology',
    subtitle: 'Name',
    definition: maDefinitions.interchangeable,
  },

  [MissionAssessmentFieldName.INTERCHANGEABLE_DESCRIPTION]: {
    title: 'Interchangeable Technology',
    subtitle: 'Description',
    definition: maDefinitions.interchangeable,
  },

  [MissionAssessmentFieldName.INTERCHANGEABLE_NOTES]: {
    title: 'Interchangeable Technology',
    subtitle: 'Notes',
    definition: maDefinitions.interchangeable,
  },

  [MissionAssessmentFieldName.EFFECT_DESCRIPTION]: {
    title: 'Effect',
    subtitle: 'Characteristics & Measures',
    definition: maDefinitions.characteristicsAndMeasures,
  },

  [MissionAssessmentFieldName.EFFECT_MEASURE_OF_IMPACT]: {
    title: 'Effect',
    subtitle: 'Measures of Impact/Effectiveness',
    definition: maDefinitions.measureOfImpactEffectiveness,
  },

  [MissionAssessmentFieldName.EFFECT_MEASURES_OF_PERFORMANCE]: {
    title: 'Effect',
    subtitle: 'Measures of Performance',
    definition: maDefinitions.measureOfPerformance,
  },
};
